<template>
  <div>
    <h3 class="mb-4">{{ $t('Hi')}} {{ userName }},</h3>
    <p>{{ currentTime }}</p>
    <v-card class="mb-4">
      <v-card-text>
        <LineChart />
      </v-card-text>
    </v-card>

    <v-row>
      <v-col cols="12" lg="6">
        <v-card class="mb-4">
          <v-card-text>
            <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        {{ $t('ID') }}
                      </th>
                      <th class="text-left">
                        {{ $t('Task name') }}
                      </th>
                      <th class="text-left">
                        {{ $t('Due date') }}
                      </th>
                      <th class="text-left">
                        {{ $t('Status') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="!tasks.length">
                      <tr>
                        <td colspan="4">{{ $t('No task doing') }}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr v-for="(item, index) in tasks" :key="`tasks-${index}`">
                      <td>{{ item.id }}</td>
                      <td>
                        <router-link :to="{ name: 'my-workings.detail', params: {id: item.id} }">{{ item.name }}</router-link>
                      </td>
                      <td>{{ dateFormat(item.due_date) }}</td>
                      <td>{{ __attr(item.status) }}</td>
                    </tr>
                    </template>
                  </tbody>
                </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="6">
        <v-card class="mb-4">
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t('ID') }}
                    </th>
                    <th class="text-left">
                      {{ $t('Project number') }}
                    </th>
                    <th class="text-left">
                      {{ $t('Project name') }}
                    </th>
                    <th class="text-left">
                      {{ $t('Status') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                   <template v-if="!projects.length">
                      <tr>
                        <td colspan="4">{{ $t('No project doing') }}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr v-for="(item, index) in projects" :key="`projects-${index}`">
                        <td>{{ item.id }}</td>
                        <td>
                          <router-link :to="{ name: 'projects.show', params: {id: item.id} }">{{ item.code }}</router-link>
                        </td>
                        <td>
                          <router-link :to="{ name: 'projects.show', params: {id: item.id} }">{{ item.name }}</router-link>
                        </td>
                        <td>{{ __attr(item.status) }}</td>
                      </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LineChart from './components/LineChart'
import { get, call } from 'vuex-pathify'
import { datetimeNow, dateFormat } from '@utils'

export default {
  name: 'Dashboard',
  components: {
    LineChart
  },
  computed: {
    userName: get('user/name'),
    ...get('dashboard', [
      'tasks', 'projects'
    ]),

    currentTime() {
      return datetimeNow('DD/MM/YYYY HH:mm')
    }
  },

  async created() {
    await this.getDashboard()
  },

  methods: {
    getDashboard: call('dashboard/index'),

    dateFormat
  }
}
</script>
